export const debounce = <T extends any[]>(fn: (...args: T) => void) => {
  let timer: number;

  return (...args: T) => {
    if (timer) {
      window.cancelAnimationFrame(timer);
    }

    timer = window.requestAnimationFrame(() => {
      fn(...args);
    });
  };
};
